import React, { useEffect } from "react";

const isBrowser = typeof window !== "undefined";

const SocialEmbed = ({ data }) => {
  const {platform, url, embedHtml} = data;
  if (embedHtml) {
    return (
      <div
        className="social-embed"
        dangerouslySetInnerHTML={{ __html: embedHtml.embedHtml }}
      />
    );
  }

  if (!url) return null;

  switch (platform) {
    case "twitter":
      return <TwitterEmbed url={url} />;

    case "instagram":
      return <InstagramEmbed url={url} />;

    case "tiktok":
      return <TikTokEmbed url={url} />;

    case "linkedin":
      return <LinkedInEmbed url={url} />;

    default:
      return (
        <a href={url} target="_blank" rel="noopener noreferrer">
          View Post
        </a>
      );
  }
};

export default SocialEmbed;

/* =========================
   Platform Components
========================= */

// 🐦 Twitter
const TwitterEmbed = ({ url }) => {
  const tweetId = url.split("/").pop();

  useEffect(() => {
    if (!isBrowser) return;

    const scriptId = "twitter-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://platform.twitter.com/widgets.js";
      script.async = true;
      document.body.appendChild(script);
    } else {
      window?.twttr?.widgets?.load();
    }
  }, []);

  return (
    <blockquote className="twitter-tweet">
      <a href={`https://twitter.com/user/status/${tweetId}`}></a>
    </blockquote>
  );
};

// 📸 Instagram
const InstagramEmbed = ({ url }) => {
  useEffect(() => {
    if (!isBrowser) return;

    const scriptId = "instagram-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://www.instagram.com/embed.js";
      script.async = true;
      document.body.appendChild(script);
    } else {
      window?.instgrm?.Embeds?.process();
    }
  }, []);

  return (
    <blockquote
      className="instagram-media"
      data-instgrm-permalink={url}
      data-instgrm-version="14"
      style={{ maxWidth: "540px", width: "100%" }}
    />
  );
};

// 🎵 TikTok
const TikTokEmbed = ({ url }) => {
  const videoId = url.split("/video/")[1];

  useEffect(() => {
    if (!isBrowser) return;

    const scriptId = "tiktok-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://www.tiktok.com/embed.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <blockquote
      className="tiktok-embed"
      cite={url}
      data-video-id={videoId}
      style={{ maxWidth: "605px", minWidth: "325px" }}
    >
      <a href={url}>View TikTok</a>
    </blockquote>
  );
};

// 💼 LinkedIn
const LinkedInEmbed = ({ url }) => {
  const postId = extractLinkedInPostId(url);

  if (!postId) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        View LinkedIn Post
      </a>
    );
  }

  return (
    <iframe
      src={`https://www.linkedin.com/embed/feed/update/${postId}`}
      height="500"
      width="100%"
      frameBorder="0"
      allowFullScreen
      title="LinkedIn Post"
    />
  );
};

const extractLinkedInPostId = (url) => {
  const match = url.match(/activity-(\d+)/);
  return match ? match[1] : null;
};